import React from 'react';
import HandPoseDetector from './HandPoseDetector';

function App() {
  return (
    <div className="App">
      <HandPoseDetector />
    </div>
  );
}

export default App;
